import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export default function AuditLog({ centers }) {
  const [logs, setLogs] = useState([]);
  useEffect(() => { api.get("/attendance/audit").then((r) => setLogs(r.data)).catch(() => {}); }, []);
  const centerName = (id) => centers.find((c) => c.id === id)?.name || "—";
  return (
    <div className="overflow-x-auto bg-white rounded-2xl border border-slate-200" data-testid="audit-log">
      <table className="w-full text-sm">
        <thead><tr className="text-left text-xs text-slate-500 border-b border-slate-200">
          {["Date/Time", "Action", "Candidate", "Finger", "User", "Center", "Device", "Quality", "Result"].map((h) => <th key={h} className="p-3">{h}</th>)}
        </tr></thead>
        <tbody>{logs.map((l) => (
          <tr key={l.id} className="border-b border-slate-100" data-testid={`audit-row-${l.action}`}>
            <td className="p-3 text-xs text-slate-500 whitespace-nowrap">{new Date(l.ts).toLocaleString()}</td>
            <td className="p-3"><span className={`text-xs font-semibold rounded-full px-2 py-0.5 ${l.action === "DELETE" ? "bg-red-100 text-red-700" : l.action === "VERIFY" ? "bg-sky-100 text-sky-800" : "bg-emerald-100 text-emerald-800"}`}>{l.action}</span></td>
            <td className="p-3">{l.candidate_name || "—"}<br /><span className="text-xs text-slate-500">{l.candidate_code}</span></td>
            <td className="p-3">{l.finger_position ?? "—"}</td>
            <td className="p-3">{l.user_name}</td>
            <td className="p-3">{centerName(l.center_id)}</td>
            <td className="p-3 text-xs">{l.device_model || "—"}<br /><span className="text-slate-500">{l.device_serial || ""}</span></td>
            <td className="p-3">{l.quality ?? "—"}</td>
            <td className="p-3 text-xs">{l.result || "—"}</td>
          </tr>))}</tbody>
      </table>
      {logs.length === 0 && <p className="text-sm text-slate-500 py-10 text-center">No audit entries yet.</p>}
    </div>
  );
}
